export const clamp = (v: number, min: number, max: number): number => {
    return v < min ? min : v > max ? max : v
}

export const smoothstep = (t: number): number => {
    return t * t * (3 - 2 * t)
}

export const easeInOutExpo = (t: number): number => {
    if (t <= 0) return 0
    if (t >= 1) return 1

    return t < 0.5
        ? Math.pow(2, 20 * t - 10) / 2
        : (2 - Math.pow(2, -20 * t + 10)) / 2
}

export const power3Out = (t: number): number => {
    return 1 - Math.pow(1 - t, 3)
}

export const power4Out = (t: number): number => {
    return 1 - Math.pow(1 - t, 4)
}

/** signed shortest distance around a ring of `n` slots, wrapped to ±n/2 */
export const wrapOff = (d: number, n: number): number => {
    let o = (((d % n) + n + n / 2) % n) - n / 2
    if (o === -n / 2) o = n / 2

    return o
}

export const prefersReducedMotion = (): boolean => {
    if (typeof window === 'undefined' || !window.matchMedia) return false

    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
